const strCompare = (str1, str2) => str1.localeCompare(str2);
const numCompare = (num1, num2) => num1 - num2;
const compare = (input, current) => typeof input === "string" ? strCompare(current, input) : numCompare(current, input);

export { compare };
//# sourceMappingURL=comparator.js.map
